// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t5pz","left":"styles_left__AzuRj","desktopActions":"styles_desktopActions__1zBcZ","title":"styles_title__LoTOW"};